export default "__VITE_ASSET__BPT5zxFl__"